import { useContext, FC, ReactNode } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import CarouselContext from './carousel-context';

const SlideItem = styled(motion.div)`
	position: absolute;
	display: block;
	width: 100%;
	height: 100%;
`;

interface Props {
	children: ReactNode | ReactNode[];
}

const SlideableCarouselItem: FC<Props> = ({ children }) => {
	const {
		animationVariants,
		animationTransition,
		direction,
		w,
		disableAnimation,
		carouselItemIndex,
		disableSwipe,
		dragElastic,
		dragConstraints,
		handleDragEnd
	} = useContext(CarouselContext);

	return disableAnimation ? (
		<SlideItem>{children}</SlideItem>
	) : (
		<SlideItem
			key={carouselItemIndex}
			custom={{ direction, w }}
			variants={animationVariants}
			transition={animationTransition}
			initial="enter"
			animate="center"
			exit="exit"
			drag={!disableSwipe && 'x'}
			dragElastic={dragElastic}
			dragConstraints={dragConstraints}
			onDragEnd={handleDragEnd}
		>
			{children}
		</SlideItem>
	);
};

export default SlideableCarouselItem;
